
import { defineComponent, PropType } from "vue";
import Spinner from "./Spinner.vue";
import FullScreenImageModal from "./FullScreenImageModal.vue";
import { getEnviromentUrl } from "@/utils/getEnvironmentURL";

export default defineComponent({
    name: "GalleryComponent",
    components: { Spinner, FullScreenImageModal },
    props: {
        images: {
            type: Array as PropType<string[]>,
            required: true,
            default: () => [],
        },
        modal: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
        },
        showLicenseInfo: {
            type: Boolean,
            default: false,
        },
        reproductionLicences: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
        reproductionCreditations: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
        licenseType: {
            type: String,
        },
        rightHolder: {
            type: String,
        },
        objectTemplate: {
            type: String,
        },
    },
    data() {
        return {
            current: 0,
            highlightIndex: 0,
            baseurl: getEnviromentUrl,
            scrollTimeout: null as number | null,
        };
    },
    methods: {
        next() {
            if (this.current < this.images.length - 1) {
                this.current++;
            } else {
                this.current = 0;
            }
            this.updateHighlight();
            this.move();
        },
        prev() {
            if (this.current > 0) {
                this.current--;
            } else {
                this.current = this.images.length - 1;
            }
            this.updateHighlight();
            this.move();
        },

        display(index: number) {
            this.current = index;
            this.updateHighlight();
            this.move();
        },
        isMultiple(): boolean {
            return this.images.length > 1;
        },
        move() {
            const boxWidth = (this.$refs.container as HTMLDivElement).scrollWidth / this.images.length;
            const scrollTo = boxWidth * this.current;

            (this.$refs.container as HTMLDivElement).scrollLeft = scrollTo;
        },
        onScroll(e: Event) {
            if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
            this.scrollTimeout = window.setTimeout(() => {
                const position = (e.currentTarget as HTMLDivElement).scrollLeft;
                const boxWidth = (this.$refs.container as HTMLDivElement).scrollWidth / this.images.length;
                this.current = Math.floor((position + boxWidth / 2) / boxWidth);
                this.highlightIndex = this.current;
            }, 100);
        },
        updateHighlight() {
            this.highlightIndex = this.current;
        },
        getCurrentLicense() {
            // Use reproductionLicences array if available
            if (this.reproductionLicences && this.reproductionLicences.length > this.current) {
                return this.reproductionLicences[this.current];
            }
            return '';
        },
        getCurrentCreditations() {
            if (
                this.reproductionCreditations &&
                this.reproductionCreditations.length > this.current
            ) {
                const raw = this.reproductionCreditations[this.current];

                if (typeof raw === 'string' && raw.includes(',')) {
                    const parts = raw.split(',').map(p => p.trim());
                    if (parts.length === 2) {
                        return `${parts[1]} ${parts[0]}`;
                    }
                }

                return raw;
            }

            return '';
        }
    },
});
